(function () {
  if (window.__luxContactEventsInstalled) return;
  window.__luxContactEventsInstalled = true;

  var privacyReady = false;
  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (error) { privacyReady = !error; }
    );
  }

  function contactMethod(href) {
    if (/^mailto:/i.test(href)) return 'email';
    if (/^tel:/i.test(href)) return 'phone';
    if (/^whatsapp:/i.test(href)) return 'whatsapp';

    try {
      var url = new URL(href, window.location.href);
      var host = url.hostname.toLowerCase();
      if (url.protocol === 'https:' &&
          (host === 'wa.me' || host === 'api.whatsapp.com' ||
           host === 'www.whatsapp.com' || host === 'web.whatsapp.com')) {
        return 'whatsapp';
      }
    } catch (error) {
      return null;
    }
    return null;
  }

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    var link = event.target.closest('a[href]');
    if (!link) return;

    var method = contactMethod(link.getAttribute('href').trim());
    if (!method || !privacyReady) return;

    var shopify = window.Shopify;
    var privacy = shopify && shopify.customerPrivacy;
    if (!privacy || typeof privacy.marketingAllowed !== 'function' ||
        !privacy.marketingAllowed() || !shopify.analytics ||
        typeof shopify.analytics.publish !== 'function') return;

    shopify.analytics.publish('luxmirrors:contact', { contact_method: method });
  }, true);
})();
